export function markUndefinedIfEmptyString(value: string | null | undefined): string | undefined {
  return value === null || value?.trim() === '' ? undefined : value;
}
